export default "__VITE_ASSET__mKQ$RP3s__"